module.exports = __webpack_public_path__ + "img/renjieBg.4bd80e46.jpg";